
export function Footer() {
  return (
    <footer className="w-full text-center py-2 text-sm text-white border-t bg-[#22398E]">
      Todos los derechos reservados. Desarrollada por{" "}
      <a
        href="https://insive.cl"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Insive SpA
      </a>
    </footer>
  );
}

